<template>
    <div class="withoutPermission_box">
        <CmpDialog
            :showClose="true"
            :visible="dialogVisible"
            :beforeClose="handleClose"
            width="800px"
            customClasses="cmp_audit_box">
            <div class="withoutPermission-dialog">
                <!-- <div class="withoutPermission-dialog-close" @click="handleClose">
                    <i class="asm-icon-close"></i>
                </div> -->
                <div class="withoutPermission-dialog-logo"></div>
                <div class="withoutPermission-dialog-tips">
                    <p>您无权限查看或操作该页面。</p>
                    <p>如有需求，请联系您的客户经理或者咨询Ext_apple@baidu.com</p>
                </div>
            </div>
            <div slot="dialog-footer">
            </div>
        </CmpDialog>
    </div>
</template>
<script>
import CmpDialog from '@/modules/cmp/components/CmpDialog';
export default {
    name: 'WithoutPermissionDialog',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CmpDialog
    },
    data() {
        return {
            // dialogVisible: false,
            dialogWidth: '500px'
        };
    },
    methods: {
        handleClose() {
            this.$emit('closePermissionDialog');
        },
        openDialog() {
            // this.dialogVisible = true;
        }
    }
};
</script>
<style lang="scss">
    .withoutPermission_box {
        .dialog-wrap {
            .el-dialog  {
                margin-top: 12% !important;
                text-align: center;
                .el-dialog__header {
                    height: 0px;
                    line-height: 0x;
                    background: none;
                }
                .el-dialog__body {
                    padding: 0;
                }
            }
        }
        .withoutPermission-dialog {
            position: relative;
            padding: 40px 0;
            .withoutPermission-dialog-close {
                position: absolute;
                top: -20px;
                right: 20px;
                cursor: pointer;
            }
            .withoutPermission-dialog-logo {
                width: 53px;
                height: 50px;
                margin: 10px auto 15px;
                background: url('../assets/images/withoutPermission.png') center center no-repeat;
                background-size: contain;
            }
            .withoutPermission-dialog-tips {
                text-align: center;
                color: #53575B;
                font-size: 14px;
                font-family: PingFangSC-Semibold;
                margin-bottom: 10px;
                line-height: 1.8;
                p {
                    margin: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/modules/cmp/components/withoutpermission.vue